<div class="content-wrapper">
    <div class="content-body ref-app">
        <div class="ref-sticky">
            <div class="ref-crumb">
                <span>Referral program / <b>{{current.title}}</b></span>
                <div ngbDropdown class="ref-hamb-wrap" placement="bottom-right" #menu="ngbDropdown">
                    <button class="ref-hamb" type="button" ngbDropdownToggle aria-label="Referral program sections">
                        <i class="fas fa-bars"></i>
                        <span class="ref-dot" *ngIf="totalPending"></span>
                    </button>
                    <div ngbDropdownMenu class="ref-menu">
                        <a *ngFor="let t of tabs" ngbDropdownItem [routerLink]="['/referral', t.path]" routerLinkActive="on"
                           (click)="menu.close()">
                            <i [class]="t.icon"></i>
                            <span>{{t.short}}</span>
                            <span class="badge badge-pill badge-danger" *ngIf="t.badge && counts[t.badge]">{{counts[t.badge]}}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <router-outlet></router-outlet>
    </div>
</div>
